/* globals google */
import $ from 'jquery';
import React , {useState} from 'react';
var postalAddress='';

export const reset = ($form) => {
    var $address = $form.find('[data-address]');

    $address.removeAttr('data-address');
    $address.removeData('address');
};

export const getGooglePlaceById = async placeId =>
    new Promise((resolve, reject) => {
        if (!placeId) reject('placeId not provided');

        try {
            new window.google.maps.places.PlacesService(
                document.createElement('div')
            ).getDetails(
                {
                    placeId,
                    fields: ['geometry'],
                },
                details => {
                    const lat = details?.geometry?.location?.lat() || null;
                    const lng = details?.geometry?.location?.lng() || null;
                    return resolve({
                        lat,
                        lng,
                    });
                }
            );
        } catch (e) {
            reject(e);
        }
    });
// export const getPostcode = async placeId => {
//     try {
//         const { lat, lng } = await getGooglePlaceById(placeId);
//         return getPostalCode(lat, lng);
//     } catch (e) {
//         console.error(e);
//         return null;
//     }
// };

const getPostalCode = async function(lat, lng) {
   return  new Promise((resolve, reject) => {
        try {
        $.ajax({
            type: 'POST',
            url: 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lng + '&sensor=true&key=AIzaSyCskHQgsrYxMj_NVHCWw6P51rSi0TZwYq8',
            dataType: 'json',
            beforeSend: function(){
            // do something before the request such as show a loading image
            },
            error: function(err){
            // handle errors
            },
            success: function(data) {
                var addresses = data.results; // cache results in a local var
                $.each(addresses, function(i){ // iterate through to find a postal code
                    if(this.types[0]=='postal_code'){ // check that the type is a postal code
                        var postal=this['address_components'][0]['long_name']; // grab postal string
                        if(postal.length > 3){ // is the result is more then 3 letter shorthand use it
                        // do something with your result and then lets break the iteration
                        //    return postal;
                            const postCode =  postal;
                            return resolve({
                                postCode,
                            });
                        }
                    }
                });
            } // end success
        });// end ajax
        } catch(e) {
        }
    });
};

export const fetchLocationName = async (lat,lng) => {
   return  new Promise((resolve, reject) =>  {
     fetch(' https://api.bigdatacloud.net/data/reverse-geocode-client?latitude='+lat+'&longitude='+lng+'&localityLanguage=en')
            .then((response) => response.json())
            .then((responseJson) => {
                const jsonData = responseJson;
                const postCodeUp = jsonData.postcode;
                const locality = jsonData.locality;
                return resolve({
                    postCodeUp,
                    locality
                });

            });
       });

};

export const populateAutocomplete = ($input, data) => {
    if($input.length < 0) return;

    console.log('Debug Autocomplete', data);

    let $form = $input.closest('.form'),
        inputName = $input.data('google-address'),
        $addressLine1 = $form.find(`[name="${inputName}[StreetNumber]"]`),
        $addressLine2 = $form.find(`[name="${inputName}[StreetName]"]`),
        $suburb = $form.find(`[name="${inputName}[Suburb]"]`),
        $postcode = $form.find(`[name="${inputName}[PostalCode]"]`),
        $state = $form.find(`[name="${inputName}[State]"]`),
        $country = $form.find(`[name="${inputName}[Country]"]`);

    if($addressLine1.length) {
        $addressLine1.val(data[`${inputName}_unit_number`] || '');
        $addressLine1.trigger('keyup');
    }

    if($addressLine2.length) {
        $addressLine2.val(data[`${inputName}_address`] || '');
        $addressLine2.trigger('keyup');
    }

    if($suburb.length) {
        $suburb.val(data[`${inputName}_suburb`] || '');
        $suburb.trigger('keyup');
    }

    if($postcode.length) {
        $postcode.val(data[`${inputName}_postcode`] || '');
        $postcode.trigger('keyup');
    }

    if($state.length) {
        $state.val(data[`${inputName}_state`] || '');
        $state.trigger('keyup');
    }

    if($country.length) {
        $country.val(data[`${inputName}_country`] || '');
        $country.trigger('keyup');
    }

    $form.find('[data-registration="address"]').first().trigger('change');
};
export const create = ($el) => {
    var $address = $el
        ? $el.find('[data-google-address]')
        : $('[data-google-address]');

    $address.each(function(i) {
        var autocomplete,
            $input = $(this),
            $form = $input.closest('.form'),
            countryRestriction = $input.data('country-restriction') || '',
            $displayedForm = $input.data('displayed-form') ? $($input.data('displayed-form')) : null,
            isAutocomplete = $input.data('autocomplete') || 0,
            options = $.extend(
                true,
                {
                    types: ['address'],
                },
                $input.data('autocomplete-options')
            );

        if(countryRestriction) {
            options.componentRestrictions = {
                country: countryRestriction.toLowerCase(),
            };
        }

        // Create the autocomplete object, restricting the search to geographical location types.
        autocomplete = new google.maps.places.Autocomplete(
            $address[i],
            options
        );

        $input.on('keydown', function(event) {
            if (event.which == 13) {
                if ($('.pac-container:visible').length) {
                    event.preventDefault();
                    return false;
                }
            } else {
                $(this).removeAttr('data-address');
                $(this).removeData('address');
            }
        });

        // on change
        google.maps.event.addListener(
            autocomplete,
            'place_changed',
            async function() {
                var place = autocomplete.getPlace(),
                    fetched_address = {},
                    combined_address = '',
                    // street_name = '',
                    // street_suffix = '',
                    // unit_number = '',
                    street_number = '',
                    street_number_1 = '',
                    street_number_2 = '',
                    newData = {},
                    inputName = $input.data('google-address')
                        ? $input.data('google-address') + '_'
                        : '',
                    lowercase_street_name = '',
                    street_array = '',
                    street_last_word = '',
                    componentForm = {
                        subpremise: 'short_name',
                        street_number: 'short_name',
                        route: 'long_name',
                        locality: 'long_name',
                        administrative_area_level_1: 'short_name',
                        country: 'long_name',
                        postal_code: 'short_name',
                    };

                const  { lat, lng } = await getGooglePlaceById(place.place_id);
                const {postCodeUp,locality} = await fetchLocationName(lat, lng);
                if (typeof place.address_components !== 'undefined')  {
                    // Get each component of the address from the place details
                    // and fill the corresponding field on the form.

                    for (var i = 0; i < place.address_components.length; i++) {
                        var addressType = place.address_components[i].types[0];
                        if (componentForm[addressType]) {
                            var val =
                                place.address_components[i][
                                    componentForm[addressType]
                                ];
                            fetched_address[addressType] = val;
                        }
                    }
                    console.log('Debug fetched_address:', fetched_address, place);
                    // Split Street Number to Unit Number & Street Number
                    if (typeof fetched_address.street_number !== 'undefined') {
                        street_number = fetched_address.street_number;

                        // append FULL ADDRESS
                        combined_address = fetched_address.street_number;
                    }

                    // Check Street Number if it has '-'
                    if (street_number !== '') {
                        if (street_number.indexOf('-') > -1) {
                            let street_number_res = street_number.split('-');
                            street_number_1 = street_number_res[0];
                            street_number_2 = street_number_res[1];
                        }
                        else if (street_number.indexOf('/') > -1) {
                            let street_number_res = street_number.split('/');
                            street_number_1 = street_number_res[0];
                            street_number_2 = street_number_res[1];
                        } else {
                            street_number_1 = street_number;
                        }
                    }

                    // Check for suffix in street_name
                    if (typeof fetched_address.route !== 'undefined') {
                        lowercase_street_name = fetched_address.route.toLowerCase();
                        street_array = lowercase_street_name.split(' ');
                        street_last_word = street_array[street_array.length - 1];

                        // append FULL ADDRESS
                        if (combined_address.length) {
                            combined_address += ' ';
                        }
                        combined_address += fetched_address.route;
                    }

                    // new data
                    newData[inputName + 'address'] = combined_address;
                    newData[inputName + 'street_type'] = street_last_word;
                    newData[inputName + 'unit_number'] = fetched_address.subpremise;
                    newData[inputName + 'street_number'] = street_number_1;
                    newData[inputName + 'street_number_2'] = street_number_2;
                    newData[inputName + 'street_name'] = fetched_address.route;
                    newData[inputName + 'suburb'] = fetched_address.locality ? fetched_address.locality : locality;
                    newData[inputName + 'postcode'] = fetched_address.postal_code ? fetched_address.postal_code : postCodeUp ;
                    newData[inputName + 'state'] = fetched_address.administrative_area_level_1;
                    newData[inputName + 'country'] = fetched_address.country;
                    // lazy backend code
                    if (inputName == 'check') {
                        delete newData.check_street_type;
                        newData.street_type = street_last_word;
                    }

                    // console.log('NORMAL data');
                    // console.log(newData);
                    // console.log('PARAM data');
                    // console.log($.param(newData));

                    // append data
                    // $input.data('address', $.param(newData));
                    $input.attr('data-address', true);
                    $input.data('address', newData);

                    // force validation
                    $input.trigger('keyup.field');

                    // keep data
                    $form.trigger('update', $input);
                } else {
                    // append data
                    // $input.data('address', place.name);
                    console.log('no address data');
                }
                if(isAutocomplete) {
                    populateAutocomplete($input, newData);
                }
                if($displayedForm && $displayedForm.length) {
                    $displayedForm.slideDown();
                }
            }
        );
    });
};



export const showFullAddress = ($el) => {
    var $block = $el.closest('[data-block]'),
        $nextBlock = $block.next();

    $nextBlock.slideDown();
    // $nextBlock.removeClass('hidden');
    // $block.addClass('hidden');
};
export const binds = ($el) => {
    create();
    // ---------------- show full address form
    $('#wrapper').on('click.address', '[data-show-fullform]', function(event) {
        event.preventDefault();
        showFullAddress($(this));
    });
};
